var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChangePwd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#0078D4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1236_4460",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1236_4460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 27C19.8333 27 20.5417 26.7083 21.125 26.125C21.7083 25.5417 22 24.8333 22 24C22 23.1667 21.7083 22.4583 21.125 21.875C20.5417 21.2917 19.8333 21 19 21C18.1667 21 17.4583 21.2917 16.875 21.875C16.2917 22.4583 16 23.1667 16 24C16 24.8333 16.2917 25.5417 16.875 26.125C17.4583 26.7083 18.1667 27 19 27ZM19 30C17.3333 30 15.9167 29.4167 14.75 28.25C13.5833 27.0833 13 25.6667 13 24C13 22.3333 13.5833 20.9167 14.75 19.75C15.9167 18.5833 17.3333 18 19 18C20.35 18 21.5292 18.3833 22.5375 19.15C23.5458 19.9167 24.25 20.8667 24.65 22H33.025L35 23.975L31.5 27.975L29 26L27 28L25 26H24.65C24.2333 27.2 23.5083 28.1667 22.475 28.9C21.4417 29.6333 20.2833 30 19 30Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChangePwd);
export default __webpack_public_path__ + "static/media/ic_change_pwd.72a4f878a9acaa27cdb6ed9c954ecbc0.svg";
export { ForwardRef as ReactComponent };